import { useRef } from 'react'
import { Box, Typography, Modal, IconButton, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined'
import { PanZoom } from 'react-easy-panzoom'
import styles from './styles.module.scss'

const ZoomImageModal = (props) => {
    const { isOpen, handleClose, src, title } = props;
    const panZoomRef = useRef(null)

    const handleZoomIn = () => {
        if (panZoomRef.current) {
            panZoomRef.current.zoomIn(5)
        }
    }

    const handleZoomOut = () => {
        if (panZoomRef.current) {
            panZoomRef.current.zoomOut(3.77)
        }
    }

    const handleReset = () => {
        if (panZoomRef.current) {
            panZoomRef.current.reset()
        }
    }

    if(!src) return;

    return (
        <Modal
            className={styles.zoomModalSection}
            open={isOpen}
            onClose={handleClose}
        >
            <Box className={styles.zoomContent}>
                <Typography className={styles.zoomTitle}>
                    {title}
                </Typography>
                <IconButton className={styles.zoomCloseButton} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <Box className={styles.zoomImageContainer}>
                    <PanZoom
                        ref={panZoomRef}
                        className={styles.panZoomContainer}
                    >
                        <img
                            className={styles.zoomImage}
                            src={src}
                            alt="Zoom"
                        />
                    </PanZoom>
                </Box>
                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                <IconButton className={styles.zoomIconButton} onClick={handleZoomIn}>
                    <AddIcon />
                </IconButton>
                <IconButton className={styles.zoomIconButton} onClick={handleZoomOut}>
                    <RemoveIcon />
                </IconButton>
                <IconButton className={styles.zoomIconButton} onClick={handleReset}>
                    <BlockOutlinedIcon />
                </IconButton>
                </Stack>
            </Box>
        </Modal>
    )
}

export default ZoomImageModal
